module.exports = __webpack_public_path__ + "static/mr-online-program-music-world-wide-5-29b1d075b3f66c077d66c9f7f6d30811.jpg";